import Icon from "@ant-design/icons";

const icon = () => (
  <svg
    t="1578467129631"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="13845"
    width="1em"
    height="1em"
  >
    <defs>
      <style type="text/css"></style>
    </defs>
    <path
      d="M777 110.382C777 102.991 771.009 97 763.618 97H292.382C284.991 97 279 102.991 279 110.382v802.236c0 7.391 5.991 13.382 13.382 13.382h471.236c7.391 0 13.382-5.991 13.382-13.382V110.382zM498.03 131h143.857c8.315 0 15.055 6.685 15.055 15s-6.74 15-15.055 15H498.03c-8.315 0-15.055-6.685-15.055-15s6.74-15 15.055-15z m-60.219 1.583c8.315 0 15.055 6.74 15.055 15.055s-6.74 15.055-15.055 15.055-15.055-6.74-15.055-15.055 6.74-15.055 15.055-15.055z m89.91 771.98c-25.406 0-46.001-20.595-46.001-46.001s20.595-46.001 46.001-46.001 46.001 20.595 46.001 46.001c0 25.405-20.595 46.001-46.001 46.001zM731 788H323V206h408v582z"
      fill="#53AFFD"
      p-id="13846"
    ></path>
    <path
      d="M810 110.837C810 84.97 789.03 64 763.163 64H291.837C265.97 64 245 84.97 245 110.837v802.325C245 939.03 265.97 960 291.837 960h471.325C789.03 960 810 939.03 810 913.163V110.837z m-33 801.781c0 7.391-5.991 13.382-13.382 13.382H292.382c-7.391 0-13.382-5.991-13.382-13.382V110.382C279 102.991 284.991 97 292.382 97h471.236c7.391 0 13.382 5.991 13.382 13.382v802.236z"
      p-id="13847"
    ></path>
    <path
      d="M323 206h408v582H323zM481.72 858.562a46.001 46.001 0 1 0 92.002 0 46.001 46.001 0 1 0-92.002 0zM422.756 147.638a15.055 15.055 0 1 0 30.11 0 15.055 15.055 0 1 0-30.11 0zM498.03 161h143.857c8.315 0 15.055-6.685 15.055-15s-6.74-15-15.055-15H498.03c-8.315 0-15.055 6.685-15.055 15s6.74 15 15.055 15z"
      fill="#FFFFFF"
      p-id="13848"
    ></path>
  </svg>
);

const IconMobile = (props) => <Icon component={icon} {...props} />;

export default IconMobile;
